<template>
  <template v-for="(fragment, index) in processedText" :key="index">
    <h3 v-if="fragment.type === 'header'" :style="fragment.style">
      <KyMixedText :text-content="fragment.text" v-bind="$attrs" />
    </h3>
    <div v-else-if="fragment.type === 'option'" :style="fragment.style" class="option">
      <KyMixedText :text-content="fragment.text" v-bind="$attrs" />
      <img src="@/assets/img/feedback/arrow_right.png" />
    </div>
    <a v-else-if="fragment.type === 'link'" @click="fragment.httpUrl ? null : $emit('to-link', fragment.url, $event)"
      :href="fragment.httpUrl" target="_blank" :style="fragment.style" :data-url="fragment.url" class="link">
      <KyMixedText :text-content="fragment.text" v-bind="$attrs" />
    </a>
    <a v-else-if="fragment.type === 'send'" @click="$emit('to-send', fragment.text, $event)" :style="fragment.style">
      <KyMixedText :text-content="fragment.text" v-bind="$attrs" />
    </a>
    <div v-else-if="fragment.type === 'paragraph'" :style="fragment.style">
      <KyMixedText :text-content="fragment.text" v-bind="$attrs" />
    </div>
    <template v-else>
      <span :style="fragment.style" class="plain-text"> {{ fragment.text }}</span>
    </template>
  </template>
</template>

<script>
export default {
  name: 'KyMixedText',
  props: {
    textContent: {
      type: String,
      default: '',
    },
    style: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    processedText() {
      // 文本被解析并分割成多个有不同格式的片段
      const textFragments = this.parseText(this.textContent)
      return textFragments
    },
  },
  methods: {
    /**
     *
     * @param text {string} 待解析的文本
     */
    parseText(text) {
      // 用于存储分割后的文本片段
      const fragments = []
      // 定义文本格式的正则表达式
      const formatPatterns = [
        { type: 'theme', pattern: /@#(.*?)@#/g, style: { color: '#F7365D' } }, // 主题色文本
        { type: 'bold', pattern: /@b(.*?)@b/g, style: { fontWeight: 'bold' } }, // 加粗文本
        {
          // 链接文本
          type: 'link',
          pattern: /(?:@@|@link#)(.*?)(?:@@|@link#)/g,
          style: { color: '#6EAFCC' },
        },
        {
          // 发送文本
          type: 'send',
          pattern: /@send#(.*?)@send#/g,
          style: { color: '#6EAFCC' },
        },
        {
          // 选项
          type: 'option',
          pattern: /@option#(.*?)@option#/g,
          style: {},
        },
        {
          // 标题
          type: 'header',
          pattern: /@header#(.*?)@header#/g,
          style: {},
        },
        {
          // 段落
          type: 'paragraph',
          pattern: /@p#(.*?)@p#/g,
          style: {},
        },
      ]

      /**
       *
       * @param content {string}
       * @param item {typeof formatPatterns[number]}
       * @returns {typeof fragments[number]}
       */
      function transferText(content, item) {
        if (item?.type === 'link') {
          const [url, txt] = content.split('|');
          return {
            ...item,
            text: txt,
            url,
            httpUrl: url?.startsWith('http') ? url : undefined,
          };
        }
        return { ...item, text: content };
      }


      const combineReg = new RegExp(formatPatterns.map(({ pattern, type }) => `(?<${type}>${pattern.source})`).join('|'),
        Array.from(new Set(formatPatterns.flatMap(({ pattern }) => pattern.flags.split('')))).join(''));
      // 合并正则匹配保证顺序匹配，且只匹配外层，内层会递归嵌套组件处理
      do {
        const lastIndex = combineReg.lastIndex;
        const match = combineReg.exec(text);
        if (!match) {
          const behindText = text.slice(lastIndex, text.length);
          if (behindText) {
            fragments.push({ text: behindText }); // 匹配后的文本填充
          }
          break;
        }
        const targetRule = formatPatterns.find(({ type }) => match?.groups?.[type]);
        const endIndex = match?.index + match.groups?.[targetRule?.type]?.length ?? 0;
        const startIndex = match?.index;
        const frontText = text.slice(lastIndex, startIndex);
        const content = text.slice(startIndex, endIndex).replace(targetRule?.pattern, '$1');
        if (frontText) {
          fragments.push({ text: frontText }); // 匹配前的文本填充
        }
        fragments.push(transferText(content, targetRule))
      } while (combineReg.lastIndex);

      if (!fragments.length) {
        fragments.push({ text })
      }
      return fragments
    },
  },
}
</script>

<style lang="less" scoped>
.link {
  cursor: pointer;
}

.option {
  align-items: center;
  background: hsla(0, 0%, 100%, .04);
  border-radius: .16rem;
  display: flex;
  justify-content: space-between;
  margin: .16rem 0;
  padding: .24rem;
  position: relative;

  >img {
    margin-left: .16rem;
    height: .32rem;
    width: .32rem;
  }

  .plain-text {
    color: rgba(255, 255, 255, 0.9);
  }
}
</style>
